import apiClient from './client';

export interface AgentApiToken {
  id: string;
  agent_id: string;
  name: string | null;
  token_prefix: string | null;
  scopes: string[];
  is_active: boolean;
  expires_at: string | null;
  last_used_at: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface AgentApiTokenWithSecret extends AgentApiToken {
  token: string;
}

export interface CreateAgentApiTokenRequest {
  name?: string;
  scopes?: string[];
  expires_at?: string | null;
}

export interface UpdateAgentApiTokenRequest {
  name?: string;
  is_active?: boolean;
  expires_at?: string | null;
}

export async function listAgentApiTokens(agentId: string): Promise<AgentApiToken[]> {
  const response = await apiClient.get(`/agents/${agentId}/tokens`);
  return response.data;
}

export async function createAgentApiToken(
  agentId: string,
  data: CreateAgentApiTokenRequest
): Promise<AgentApiTokenWithSecret> {
  const response = await apiClient.post(`/agents/${agentId}/tokens`, data);
  return response.data;
}

export async function updateAgentApiToken(
  agentId: string,
  tokenId: string,
  data: UpdateAgentApiTokenRequest
): Promise<AgentApiToken> {
  const response = await apiClient.patch(`/agents/${agentId}/tokens/${tokenId}`, data);
  return response.data;
}

export async function deleteAgentApiToken(agentId: string, tokenId: string): Promise<void> {
  await apiClient.delete(`/agents/${agentId}/tokens/${tokenId}`);
}
